import { normalizeAllowedRedirectPath } from "@miadvg/auth-gateway/shared";

/** Registered TaxRise auth-gateway staff app slug (must match gateway registration). */
export const BOOKING_STAFF_APP_SLUG = "booking";
export const BOOKING_STAFF_AUTH_CALLBACK_PATH = "/auth/callback";
export const BOOKING_STAFF_SIGN_OUT_PATH = "/api/auth/sign-out";

export const BOOKING_STAFF_ALLOWED_REDIRECT_PREFIXES = [
  "/admin",
] as const;

export function normalizeBookingStaffRedirectPath(
  rawValue: string | null | undefined,
): string {
  return normalizeAllowedRedirectPath(rawValue, {
    fallback: "/admin",
    allowedPrefixes: [...BOOKING_STAFF_ALLOWED_REDIRECT_PREFIXES],
  });
}
